export const BOOKING_TYPE_TEST = 'booking_test'
export const BOOKING_TYPE_VIDEO = 'booking_video'
